// ─── Mises à jour base adhérents — Avril 2026 ─────────────────────────────────
// Source : croisement listes BFCNET officielles × relevés BFC Jan/Fév/Mar 2026
// Appliqué UNE SEULE FOIS via le garde _updates2026Applied dans migrate()
// Les statuts payé ne remplacent jamais un pointage manuel existant.
// Les défauts (ACTION 1 & 2) sont toujours forcés (motif enrichi avec alerte).

import { uid } from '../utils/helpers';

// ─── Cotisations T1 2026 (trimestriels — paiement BFC 02/02/2026) ─────────────
// 37 adhérents confirmés encaissés (hors HOARAU Judith défaut + CADENA à créer)
const TRIM_T1_IDS = [
  'imp-0218', // AMOUNY Karine
  'imp-0219', // ANDOCHE Arnaud
  'imp-0220', // AUNG-A-SING Audrey
  'imp-0221', // BAILLIF Annie Claude
  'imp-0222', // BARRET Marie Yvette
  'imp-0223', // BARRET Séverine
  'imp-0224', // BEGUE Yanick & Aliette
  'imp-0225', // BEGUE Karen
  'imp-0226', // CADAR Sandrine
  'imp-0227', // CHAMAND Cynthia
  'imp-0228', // ERAMBERT Joann
  'imp-0229', // ESPARON Sandrine
  'imp-0230', // FOLIO Cindy
  'imp-0231', // FONTAINE Sophie
  'imp-0232', // FRANCOISE Elodie
  'imp-0233', // GAZEUSE Olivia
  'imp-0234', // GONTHIER Marine
  'imp-0235', // GRONDIN Corinne
  'imp-0236', // HAUDEBOURG Jean Philippe
  // imp-0237 = HOARAU Judith — EXCLU (défaut T1)
  'imp-0238', // HOAREAU Frédéric
  'imp-0239', // LAFUTEUR Gabrièle
  'imp-0240', // M'CAZA Cédric
  'imp-0241', // MOUILLON Béatrice
  'imp-0242', // MUSSARD Dina
  'imp-0243', // NALATIAPOULE Achille
  'imp-0244', // PAYET Mélanie
  'imp-0245', // POLEYA Catherine
  'imp-0246', // PRAENE Johane
  'imp-0247', // RIVIÈRE Laurence
  'imp-0248', // SANARA Marie Sabrina
  'imp-0249', // SERY Marie Patricia
  'imp-0250', // SINACOUTY Jessie
  'imp-0251', // SMITH Anne Laure
  'imp-0252', // VIDOT Edwige
  'imp-0303', // FOLIO Chantal   (était Suspendu → Actif ici)
  'imp-0304', // JULIE Barbara   (était Suspendu → Actif ici)
  'imp-0305', // SUZANNE Freddy  (était Suspendu → Actif ici)
];

// ─── Cotisations S1 2026 (semestriels — paiement BFC 02/02/2026) ──────────────
// 21 adhérents confirmés encaissés (hors TESTAN Emeline défaut)
const SEM_S1_IDS = [
  'imp-0197', // BENARD Annie Claude
  'imp-0198', // BUREL Patricia
  'imp-0199', // CARPAYE Lorraine
  'imp-0200', // CHAMBINA Marina
  'imp-0201', // CLAIN Marie Ange
  'imp-0202', // GREMIAUX Patrice
  'imp-0203', // GRIMAUD Delphine
  'imp-0204', // GRONDIN Ingrid
  'imp-0205', // GRONDIN Wendy
  'imp-0206', // HOARAU Paméla
  'imp-0207', // HOARAU Pascal
  'imp-0208', // HOARAU Sarah Marie
  'imp-0209', // LEBON Samuel
  'imp-0210', // LECLERC Lucine
  'imp-0211', // MAZELI Rudy
  'imp-0212', // NATIVEL Jean
  'imp-0213', // PAYET Kelly
  'imp-0214', // PERSEE Cillon
  'imp-0215', // PROCHASSON Rosy
  'imp-0216', // TAMBON Séverine
  // imp-0217 = TESTAN Emeline — EXCLU (contestation active)
  'imp-0302', // CELESTE Éric    (était Suspendu → Actif ici)
];

// ─── Fonction principale ───────────────────────────────────────────────────────
export function applyUpdates2026(state) {
  if (state._updates2026Applied) return state;

  const year = 2026;

  // ── 1. Modifications adhérents ───────────────────────────────────────────────
  let adherents = state.adherents.map(a => {
    switch (a.id) {
      // ACTION 1 — VALIN Fabienne → confirmer SUSPENDU
      case 'imp-0258':
        return { ...a, statut: 'Suspendu' };

      // ACTION 3 — CADENA Isabelle → corriger Annuelle→Trimestrielle, 108€→27€
      case 'imp-0196':
        return { ...a, periodicite: 'Trimestrielle', montant: 27.0 };

      // ACTION 4 — PITOU Maryanna : J1 → J5
      case 'imp-0040':
        return { ...a, jourPrelevement: '5' };

      // ACTION 4 — SAUTRON Loyce : J3 → J5
      case 'imp-0075':
        return { ...a, jourPrelevement: '5' };

      // ACTION 5 — Trimestriels Suspendu → Actif (paiement confirmé)
      case 'imp-0303': // FOLIO Chantal
      case 'imp-0304': // JULIE Barbara
      case 'imp-0305': // SUZANNE Freddy
        return { ...a, statut: 'Actif' };

      // ACTION 6 — Semestriel Suspendu → Actif (paiement confirmé)
      case 'imp-0302': // CELESTE Éric
        return { ...a, statut: 'Actif' };

      default:
        return a;
    }
  });

  // ── 2. Ajouter SERY Mickaël s'il est absent ─────────────────────────────────
  const hasSery = adherents.some(a => a.numero === 'SDA-SERMIK-077');
  let seryId = hasSery
    ? adherents.find(a => a.numero === 'SDA-SERMIK-077').id
    : null;

  if (!hasSery) {
    seryId = uid();
    adherents = [...adherents, {
      id:               seryId,
      prenom:           'Mickaël',
      nom:              'SERY',
      numero:           'SDA-SERMIK-077',
      statut:           'Actif',
      etablissementId:  '',
      metier:           '',
      contrat:          'CDI',
      dateEntree:       '',
      convention:       'CCN 51',
      coefficient:      '',
      dateAdhesion:     '',
      modePaiement:     'Prélèvement auto',
      jourPrelevement:  '3',
      periodicite:      'Mensuelle',
      montant:          9.0,
      rib:              '',
      telephone:        '',
      email:            '',
      adresse:          '',
      notes:            'RUM: SDA-SERMIK-077 | Intégré suite analyse relevé BFC 03/2026',
    }];
  }

  // ── 3. Cotisations ────────────────────────────────────────────────────────────
  const cots = JSON.parse(JSON.stringify(state.cotisations || {}));
  if (!cots[year]) cots[year] = {};

  // Pose un payé si le mois n'est pas encore pointé
  const setPayé = (id, months, motif) => {
    if (!cots[year][id]) cots[year][id] = {};
    for (const m of months) {
      if (!cots[year][id][m]) {
        cots[year][id][m] = { status: 'paye', motif };
      }
    }
  };

  // Force le défaut (écrase toujours pour enrichir le motif avec le niveau d'alerte)
  const setDéfaut = (id, monthMotifs) => {
    if (!cots[year][id]) cots[year][id] = {};
    for (const [mStr, motif] of Object.entries(monthMotifs)) {
      cots[year][id][parseInt(mStr, 10)] = { status: 'defaut_provision', motif };
    }
  };

  // ── ACTION 1 — VALIN Fabienne : défaut Jan/Fév/Mar (mandat désactivé) ─────
  setDéfaut('imp-0258', {
    1: 'Prélèvement non exécuté — Mandat SDA-VALFAB-11 — à désactiver',
    2: 'Prélèvement non exécuté — Mandat SDA-VALFAB-11 — 2ème mois consécutif',
    3: 'Prélèvement non exécuté — Mandat SDA-VALFAB-11 — 3ème mois — 27€ non recouvrés',
  });

  // ── ACTION 2 — Défauts adhérents actifs (avec niveaux d'alerte) ───────────

  // DARID Geneviève — 🟥 ROUGE — 3 défauts consécutifs — décision syndicale
  setDéfaut('imp-0095', {
    1: '🟥 ROUGE — Provision insuffisante — 1er défaut',
    2: '🟥 ROUGE — Provision insuffisante — 2ème défaut consécutif',
    3: '🟥 ROUGE — Provision insuffisante — 3ème défaut — décision syndicale à engager',
  });

  // DAGARD Marie Sandra — 🟧 ORANGE — 2 défauts — à contacter
  setDéfaut('imp-0185', {
    1: '🟧 ORANGE — Compte bloqué — à contacter en priorité',
    2: '🟧 ORANGE — Provision insuffisante — 2ème défaut — à contacter en priorité',
  });

  // TESTAN Emeline — 🟥 ROUGE — Contestation URGENT
  setDéfaut('imp-0217', {
    3: '🟥 ROUGE — Contestation débiteur 54€ — URGENT — contester validité mandat SEPA',
  });

  // SERY Mickaël — 🟡 JAUNE — 1er défaut — surveiller
  if (seryId) {
    setDéfaut(seryId, {
      3: '🟡 JAUNE — Service spécialisé banque du tiré — 1er défaut — surveiller avril 2026',
    });
  }

  // HOARAU Judith — 🟡 JAUNE — Défaut T1 trimestriel
  setDéfaut('imp-0237', {
    2: '🟡 JAUNE — Provision insuffisante — Prélèvement trimestriel 27€ T1 2026 — 1er défaut — surveiller T2',
  });

  // ── ACTION 5 — Trimestriels T1 2026 (Jan + Fév + Mar) ────────────────────
  for (const id of TRIM_T1_IDS) {
    setPayé(id, [1, 2, 3], 'Prélèvement T1 2026 — BFC 02/02/2026');
  }

  // ── ACTION 6 — Semestriels S1 2026 (Jan → Jun) ───────────────────────────
  for (const id of SEM_S1_IDS) {
    setPayé(id, [1, 2, 3, 4, 5, 6], 'Prélèvement S1 2026 — BFC 02/02/2026');
  }

  console.info('[seedUpdates2026] Actions 1-6 appliquées. SERY Mickaël', hasSery ? '(existait déjà)' : '(créé)');

  return { ...state, adherents, cotisations: cots, _updates2026Applied: true };
}
